import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Calendar } from '../../../../components/calendar';
import { addLocale } from 'primereact/api';
import { get, orderBy, isEmpty } from 'lodash';

import dateFormat from 'dateformat';

import 'react-toastify/dist/ReactToastify.css';

import { displayErrors } from '../../../../util/diversos';
import { fillColumns } from '../../../../components/table';
import { Input100px, Input155px } from '../../../../styles/inputGroup';

import store from '../../../../store/store';
import axiosAdmin from '../../../../services/axiosAdmin';
import Card from '../../../../components/card';
import Loading from '../../../loading';
import CadastroEventoNFe from './cadastroEventoNFe';
import PdfOrcamento from '../../relatorio/pdfOrcamento';

import ConsultaNFe from '../../nfe/consultaNFe';

import * as actions from '../../../../store/modules/auth/actions';

addLocale('pt-BR', {
  firstDayOfWeek: 0,
  dayNames: ['domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado'],
  dayNamesShort: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
  dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
  monthNames: ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'],
  monthNamesShort: ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
  today: 'hoje',
  clear: 'Limpar',
});

export default function ConsultaEventoNFe({ somenteLeitura = false }) {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [cnpjEmpresa, setCnpjEmpresa] = useState('');

  const [showCadastro, setShowCadastro] = useState(false);
  const [showConsultaNFe, setShowConsultaNFe] = useState(false);
  const [showPrint, setShowPrint] = useState(false);

  const [totalRecords, setTotalRecords] = useState(0);
  const [dataTableList, setDataTableList] = useState([]);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [selectedItens, setSelectedItens] = useState(null);
  const [findDataInicial, setFindDataInicial] = useState(null);
  const [findDataFinal, setFindDataFinal] = useState(null);
  const [listaTipoEventoDFe, setListaTipoEventoDFe] = useState(null);
  const [findCodigoEventoDFe, setFindCodigoEventoDFe] = useState(null);
  const [findChaveAcessoNFe, setFindChaveAcessoNFe] = useState('');

  const [sortField, setSortField] = useState('descricao');
  const [sortOrder, setSortOrder] = useState(null);
  const [payloadCadastro, setPayloadCadastro] = useState({});
  const [payloadPrint, setPayloadPrint] = useState({});

  const [listaEmpresas, setListaEmpresas] = useState([]);

  const [columnsSetup] = useState([
    { field: 'data', header: 'Data', sort: true },
    { field: 'tpEvento', header: 'Evento', sort: true },
    { field: 'nseqEvento', header: 'Núm. Sequencia', sort: true },
    { field: 'cnpj', header: 'CNPJ', sort: false },
    { field: 'chaveNFe', header: 'Chave NFe', sort: false },
    { field: 'protocoloAutorizacao', header: 'Protocolo Autorização', sort: false },
    { field: 'protocoloCancelamento', header: 'Protocolo Cancelamento', sort: false },
    { field: 'codigoSituacao', header: 'Código Situação', sort: false },
    { field: 'flag', header: 'Enviado', sort: false },
  ]);
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: 10,
    page: 0,
    sortField: null,
    sortOrder: null,
    filters: null,
  });



  async function getData(searchFilter, page, size) {
    try {
      setIsLoading(true);

      const idUsuario = get(store.getState().auth.user, 'id', 0);

      let params = `/eventodfe/search?idUsuario=${idUsuario}`;

      if (searchFilter && searchFilter.findDataInicial !== '') {
        const _dataInicial = dateFormat(searchFilter.findDataInicial, 'dd-mm-yyyy');
        const _dataFinal = dateFormat(searchFilter.findDataFinal, 'dd-mm-yyyy');

        params = `${params}&dataInicial=${_dataInicial}&dataFinal=${_dataFinal}`;
      }

      if (findChaveAcessoNFe) {
        params = `${params}&chaveAcesso=${findChaveAcessoNFe}`;
      }

      if (findCodigoEventoDFe) {
        params = `${params}&codigoEventoDFe=${findCodigoEventoDFe}`;
      }

      params = `${params}&page=${page}&size=${size}`;

      const response = await axiosAdmin.get(params);

      // console.log('response.data.content: ', response.data.content);

      setDataTableList(response.data.content);
      setTotalRecords(response.data.totalElements);
    } catch (err) {
      displayErrors(err, dispatch, navigate, '/', '');
    } finally {
      setIsLoading(false);
    }
  }

  const handleFind = () => {
    const searchFilter = { findDataInicial, findDataFinal, findChaveAcessoNFe, findCodigoEventoDFe };

    const _lazyParams = { ...lazyParams, first: 0, page: 0 };

    setLazyParams(_lazyParams);

    getData(searchFilter, 0, lazyParams.rows);
  };

  useEffect(() => {
    async function getTipoEventoDFe() {
      const listDropdown = [];
      try {
        setIsLoading(true);

        const { data: _tipoEventoNFe } = await axiosAdmin.get('/tipoeventodfe/');

        listDropdown.push({ label: 'Todos', value: null });
        _tipoEventoNFe.forEach(element => {
          listDropdown.push({ label: `${element.codigo} - ${element.descricao}`, value: element.codigo });
        });

        setListaTipoEventoDFe(listDropdown);
      } catch (err) {
        displayErrors(err, dispatch, navigate, '/', '');
      } finally {
        setIsLoading(false);
      }
    }
    getTipoEventoDFe();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleRegister = () => {
    const id = 0;

    setPayloadCadastro({ id, cnpjEmpresa });

    setShowCadastro(true);
  };

  const handleEdit = (e) => {
    e.preventDefault();

    const id = get(selectedItens, 'id', 0);

    if (id > 0) {
      setPayloadCadastro({ id, cnpjEmpresa });
      setShowCadastro(true);
    } else {
      toast.warning('Por favor, selecione o registro para edição');
    }
  };

  const handleDelete = (e) => {
    e.preventDefault();

    const id = get(selectedItens, 'id', 0);

    if (id > 0) {
      setShowConfirmDialog(true);
    } else {
      toast.warning('Por favor, selecione o registro para exclusão');
    }
  };

  const cancelDelete = () => {
    setShowConfirmDialog(false);
  };

  const confirmDelete = async () => {
    setShowConfirmDialog(false);

    try {
      setIsLoading(true);

      const idExclusao = get(selectedItens, 'id', 0);

      if (idExclusao > 0) {
        await axiosAdmin.delete(`/eventodfe/${idExclusao}`);

        const searchFilter = { findDataInicial, findDataFinal, findChaveAcessoNFe, findCodigoEventoDFe };

        getData(searchFilter, 0, lazyParams.rows);

        toast.success('Registro excluído com sucesso');
      }
    } catch (err) {
      displayErrors(err, dispatch, navigate, '', 'Não foi possível excluir o registro');
    } finally {
      setIsLoading(false);
    }
  };

  const confirmDialogFooter = (
    <div>
      <Button label="Sim" icon="pi pi-check" onClick={confirmDelete} />
      <Button label="Não" icon="pi pi-times" onClick={cancelDelete} />
    </div>
  );

  const onSort = (e) => {
    setSortField(e.sortField);
    setSortOrder(e.sortOrder);

    setDataTableList(orderBy(dataTableList, [sortField], [sortOrder]));
  };

  const onPage = (event) => {
    setLazyParams(event);

    const searchFilter = { findDataInicial, findDataFinal, findChaveAcessoNFe, findCodigoEventoDFe };

    getData(searchFilter, event.page, event.rows);
  };

  const onHideCadastro = () => {
    setShowCadastro(false);
  };

  const childToParentCadastro = (payloadDataTableList, id) => {
    if (payloadDataTableList) {
      if (id > 0) {
        const searchFilter = { findDataInicial, findDataFinal, findChaveAcessoNFe, findCodigoEventoDFe };

        getData(searchFilter, lazyParams.page, lazyParams.rows);
      } else {
        const _dataTableList = [];
        _dataTableList.push(payloadDataTableList);

        setDataTableList(_dataTableList);

        const _lazyParams = { ...lazyParams, first: 0, page: 0 };
        setLazyParams(_lazyParams);
        setTotalRecords(1);
      }
    }

    setShowCadastro(false);
  };

  const handlePrint = (e) => {
    e.preventDefault();

    const id = get(selectedItens, 'id', 0);

    if (id > 0) {
      setPayloadPrint({ id });
      setShowPrint(true);
    } else {
      toast.warning('Por favor, selecione o registro para edição');
    }
  };

  const onHidePrint = () => {
    setShowPrint(false);
  };

  const finishPrintOrcamento = () => {
    setShowPrint(false);
  };

  const onHideConsultaNFe = () => {
    setShowConsultaNFe(false);
  };

  // eslint-disable-next-line consistent-return
  const childToParentConsultaNFe = (e) => {
    const idElement = get(e, 'id', 0);

    if (idElement > 0) {
      if (e.chaveAcesso) {
        setFindChaveAcessoNFe(e.chaveAcesso);
      } else {
        toast.warning('Nota Fiscal sem chave de acesso');
        return false;
      }
      setShowConsultaNFe(false);
    } else {
      toast.warning('Por favor, selecione o registro');
    }
  };

  useEffect(() => {
    // eslint-disable-next-line consistent-return
    async function verificarSeMultiEmpresa(idUsuario) {
      try {
        setIsLoading(true);

        const params = `/usuario/${idUsuario}`;

        const response = await axiosAdmin.get(params);

        const _listaEmpresas = get(response.data, 'listaEmpresas', []);

        if (_listaEmpresas.length === 1) {
          const { data } = await axiosAdmin.get(`/usuario/verificarvalidadeempresa/${_listaEmpresas[0].id}`);
          if (!data) {
            toast.info('Data da licença expirada. Você foi direcionado para a tela de pagamento.');
            navigate('/pagamento');
            return false;
          }
        }

        const listDropdown = [];

        const _cnpjConsultaPrevisaoFinanceiraCjpEmpresa = store.getState().auth.consultaPrevisaoFinanceiraCnpjEmpresa;

        let cnpjPreenchido = false;
        let _cnpjEmpresaStore = get(store.getState().auth, 'cnpjEmpresa', '');

        if (_cnpjConsultaPrevisaoFinanceiraCjpEmpresa === null || _cnpjConsultaPrevisaoFinanceiraCjpEmpresa === '') {
          if (_cnpjEmpresaStore !== null && _cnpjEmpresaStore !== '') {
            setCnpjEmpresa(_cnpjEmpresaStore);
            const consultaPrevisaoFinanceiraCnpjEmpresa = _cnpjEmpresaStore;
            dispatch(actions.consultaPrevisaoFinanceiraCnpjEmpresaChange({ consultaPrevisaoFinanceiraCnpjEmpresa }));
            cnpjPreenchido = true;
          }
        }

        _listaEmpresas.forEach(element => {
          if (element.ativo) {
            if (!cnpjPreenchido && (_cnpjConsultaPrevisaoFinanceiraCjpEmpresa === null || _cnpjConsultaPrevisaoFinanceiraCjpEmpresa === '')) {
              setCnpjEmpresa(element.cnpj);
              const consultaPrevisaoFinanceiraCnpjEmpresa = element.cnpj;
              dispatch(actions.consultaPrevisaoFinanceiraCnpjEmpresaChange({ consultaPrevisaoFinanceiraCnpjEmpresa }));
              _cnpjEmpresaStore = element.cnpj;
              cnpjPreenchido = true;
            }

            listDropdown.push(
              {
                label: element.razaoSocial.trim(),
                value: element.cnpj,
                serie: element.nfeSerie,
                uf: element.uf,
                nfeAmbiente: element.nfeAmbiente,
                aliquotaCofins: element.aliquotaCofins,
                aliquotaPis: element.aliquotaPis,
                id: element.id,
                regimeTributario: element.regimeTributario,
                moduloNfe: element.moduloNfe,
              });
          }
        });

        if (!isEmpty(cnpjEmpresa)) {
          _cnpjEmpresaStore = cnpjEmpresa;
          setCnpjEmpresa(cnpjEmpresa);
        }

        listDropdown.sort((a, b) => ((a.label > b.label) ? 1 : -1));

        setListaEmpresas(listDropdown);

        if (!cnpjPreenchido && _cnpjConsultaPrevisaoFinanceiraCjpEmpresa !== null && _cnpjConsultaPrevisaoFinanceiraCjpEmpresa !== '') {
          setCnpjEmpresa(_cnpjConsultaPrevisaoFinanceiraCjpEmpresa);
          _cnpjEmpresaStore = _cnpjConsultaPrevisaoFinanceiraCjpEmpresa;
        }
      } catch (err) {
        displayErrors(err, dispatch, navigate, '/', '');
      } finally {
        setIsLoading(false);
      }
    }

    if (findDataInicial === null) {
      setFindDataInicial(new Date(store.getState().auth.consultaPrevisaoFinanceiraDataInicial));
      setFindDataFinal(new Date(store.getState().auth.consultaPrevisaoFinanceiraDataFinal));

      const _dataInicial = new Date(store.getState().auth.consultaPrevisaoFinanceiraDataInicial);
      const _dataFinal = new Date(store.getState().auth.consultaPrevisaoFinanceiraDataFinal);

      const searchFilter = { findDataInicial: _dataInicial, findDataFinal: _dataFinal };

      verificarSeMultiEmpresa(get(store.getState().auth.user, 'id', 0), searchFilter);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  async function licencaValida(empresaId) {
    // eslint-disable-next-line consistent-return
    const retorno = await axiosAdmin.get(`/empresa/verificardatalicenca/${empresaId}`);
    return retorno.data;
  }

  // eslint-disable-next-line consistent-return
  async function handleCnpjEmpresa(e) {
    let empresaId = 0;

    listaEmpresas.forEach(element => {
      // console.log(element.value, e.target.value);
      if (element.value === e.target.value) {
        // eslint-disable-next-line no-unused-expressions
        empresaId = element.id;
      }
    });

    const isLicencaValida = await licencaValida(empresaId);
    if (!isLicencaValida) {
      toast.info('Cliente com licença expirada. Efetuar pagamento pelo menu -> financeiro -> pagamento online.');
      // navigate('/pagamento');
      return false;
    }

    setCnpjEmpresa(e.target.value);
  }

  // eslint-disable-next-line consistent-return
  const handleEnviar = async (e) => {
    e.preventDefault();

    /* if (!permitirEnviar) {
      toast.info('Usuário não autorizado a enviar.');
      return false;
    } */

    try {
      setIsLoading(true);

      // console.log('selecte item: ', selectedItens.id);

      const id = get(selectedItens, 'id', 0);

      if (id > 0) {
        let empresaId = 0;

        listaEmpresas.forEach(element => {
          if (element.value === cnpjEmpresa) {
            empresaId = element.id;
          }
        });

        const isLicencaValida = await licencaValida(empresaId);
        if (!isLicencaValida) {
          toast.info('Cliente com licença expirada. Efetuar pagamento mensalidade.');
          navigate('/pagamento');
          return false;
        }

        await axiosAdmin.get(`/eventodfeutil/emitirevento?id=${id}&cancelarEvento=false`).then(async () => {
          // handleDownloadArquivos(response);
          toast.success('Evento enviada com sucesso.');
        });
        handleFind();
      } else {
        toast.warning('Por favor, selecione o registro para envio');
      }
    } catch (err) {
      displayErrors(err, dispatch, navigate, '', 'Não foi possível enviar o evento');
    } finally {
      setIsLoading(false);
    }
  };

  // eslint-disable-next-line consistent-return
  const handleCancelarEventoEnviado = async (e) => {
    e.preventDefault();

    /* if (!permitirEnviar) {
      toast.info('Usuário não autorizado a enviar.');
      return false;
    } */

    try {
      setIsLoading(true);

      // console.log('selecte item: ', selectedItens);

      const id = get(selectedItens, 'id', 0);
      const flag = get(selectedItens, 'flag', 0);
      const codigoSituacao = get(selectedItens, 'codigoSituacao', 0);

      if (id > 0) {
        if (flag !== 'T') {
          toast.warning('Somente eventos enviados podem ser cancelados.');
          return false;
        }

        if (codigoSituacao === '02') {
          toast.warning('Evento já cancelado.');
          return false;
        }

        let empresaId = 0;

        listaEmpresas.forEach(element => {
          if (element.value === cnpjEmpresa) {
            empresaId = element.id;
          }
        });

        const isLicencaValida = await licencaValida(empresaId);
        if (!isLicencaValida) {
          toast.info('Cliente com licença expirada. Efetuar pagamento mensalidade.');
          navigate('/pagamento');
          return false;
        }

        await axiosAdmin.get(`/eventodfeutil/emitirevento?id=${id}&cancelarEvento=true`).then(async () => {
          // handleDownloadArquivos(response);

          toast.success('Evneto cancelado com sucesso.');
        });
        handleFind();
      } else {
        toast.warning('Por favor, selecione o registro para envio');
      }
    } catch (err) {
      displayErrors(err, dispatch, navigate, '', 'Não foi possível cancelar o evento');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Loading isLoading={isLoading} />

      <Dialog
        header="Consulta de Notas Fiscais"
        visible={showConsultaNFe}
        style={{ width: '98vw' }}
        onHide={() => onHideConsultaNFe()}
      >
        <ConsultaNFe menuMode={false} childToParent={childToParentConsultaNFe} somenteLeitura />
      </Dialog>

      <Dialog
        header=""
        closeOnEscape={false}
        visible={showCadastro}
        style={{ width: '98vw' }}
        onHide={() => onHideCadastro()}
        className="dialog-cadastro"
      >
        <CadastroEventoNFe payloadCadastro={payloadCadastro} childToParentCadastro={childToParentCadastro} />
      </Dialog>

      <Dialog
        header=""
        visible={showPrint}
        style={{ width: '98vw' }}
        onHide={() => onHidePrint()}
        className="dialog-cadastro"
      >
        <PdfOrcamento payloadPrint={payloadPrint} finishPrintOrcamento={finishPrintOrcamento} />
      </Dialog>

      <Card>
        <div>
          <div className="card mb-3">
            <h6 className="card-header" style={{ textAlign: 'center' }}>
              Controle de Eventos
            </h6>
          </div>
          <div className="row form-elo">
            <div className="col-lg-3">
              <div className="p-inputgroup">
                <Input100px className="p-inputgroup-addon">
                  Data inicial
                </Input100px>
                <Calendar
                  id="mask"
                  showIcon
                  mask="99/99/9999"
                  dateFormat="dd/mm/yy"
                  showButtonBar
                  showOnFocus={false}
                  locale="pt-BR"
                  value={findDataInicial}
                  onChange={(e) => { setFindDataInicial(e.value); }}
                />
              </div>
            </div>
            <div className="col-lg-3">
              <div className="p-inputgroup">
                <Input100px className="p-inputgroup-addon">
                  Data final
                </Input100px>
                <Calendar
                  id="mask"
                  showIcon
                  mask="99/99/9999"
                  dateFormat="dd/mm/yy"
                  showButtonBar
                  showOnFocus={false}
                  locale="pt-BR"
                  value={findDataFinal}
                  onChange={(e) => { setFindDataFinal(e.value); }}
                />
              </div>
            </div>
            <div className="col-6">
              <div className="p-inputgroup">
                <Input155px className="p-inputgroup-addon">
                  NFe
                </Input155px>
                <InputText
                  disabled
                  maxLength={44}
                  value={findChaveAcessoNFe}
                  onChange={e => setFindChaveAcessoNFe(e.target.value)}
                />
                <Button
                  icon="pi pi-search"
                  className="p-button-warning"
                  onClick={() => setShowConsultaNFe(true)}
                />
                <Button
                  icon="pi pi-times"
                  className="p-button-danger"
                  onClick={() => setFindChaveAcessoNFe('')}
                />
              </div>
            </div>
          </div>
          <div className="row form-elo">
            <div className="col-4">
              <div className="p-inputgroup">
                <Input100px className="p-inputgroup-addon">
                  Eventos
                </Input100px>
                <Dropdown
                  options={listaTipoEventoDFe}
                  value={findCodigoEventoDFe}
                  emptyMessage="Nenhum registro a ser exibido"
                  onChange={(e) => setFindCodigoEventoDFe(e.target.value)}
                />
              </div>
            </div>
            <div className="col-lg-4">
              {listaEmpresas.length > 1 ? (
                <div className="p-inputgroup">
                  <Input100px className="p-inputgroup-addon">
                    Empresa
                  </Input100px>
                  <Dropdown
                    options={listaEmpresas}
                    value={cnpjEmpresa}
                    emptyMessage="Nenhum registro a ser exibido"
                    onChange={(e) => handleCnpjEmpresa(e)}
                  />
                </div>
              ) : ('')}
            </div>
            <div className="col-lg-4">
              <button
                type="button"
                title="Buscar"
                className="btn btn-success"
                style={{ borderRadius: '15px' }}
                onClick={handleFind}
              >
                <i className="pi pi-search"></i>
              </button>
              <button
                disabled={somenteLeitura}
                type="button"
                title="Cadastrar"
                className="btn btn-primary"
                style={{ borderRadius: '15px' }}
                onClick={handleRegister}
              >
                <i className="pi pi-plus"></i>
              </button>
              <button
                disabled={somenteLeitura}
                type="button"
                title="Editar"
                className="btn btn-warning"
                style={{ borderRadius: '15px' }}
                onClick={(e) => handleEdit(e)}
              >
                <i className="pi pi-pencil"></i>
              </button>
              <button
                disabled={somenteLeitura}
                type="button"
                title="Excluir"
                className="btn btn-danger"
                style={{ borderRadius: '15px' }}
                onClick={(e) => handleDelete(e)}
              >
                <i className="pi pi-trash"></i>
              </button>
              { /* <button
                type="button"
                title="Imprimir Orçamento"
                className="btn btn-dark"
                style={{ borderRadius: '15px' }}
                onClick={(e) => handlePrint(e)}
              >
                <i className="pi pi-eye"></i>
              </button> */}
              <button
                type="button"
                title="Enviar Evento NF-e"
                className="btn btn-primary"
                style={{ borderRadius: '15px' }}
                onClick={(e) => handleEnviar(e)}
              >
                <i className="pi pi-send"></i>
              </button>
              <button
                type="button"
                title="Cancelar Evento NF-e enviado"
                className="btn btn-danger"
                style={{ borderRadius: '15px' }}
                onClick={(e) => handleCancelarEventoEnviado(e)}
              >
                <i className="pi pi-send" style={{ transform: 'rotate(180deg)' }}></i>
              </button>
            </div>
          </div>
          <br />
          <div className="row align-items-center" style={{ marginTop: '10px' }}>
          </div>
        </div>
        <br />

        <div className="card">
          <DataTable
            value={dataTableList}
            size="small"
            stripedRows
            responsiveLayout="scroll"
            sortField={sortField}
            sortOrder={sortOrder}
            onSort={onSort}
            selectionMode="single"
            selection={selectedItens}
            onSelectionChange={e => setSelectedItens(e.value)}
            selectableRows
            dataKey="id"
            paginator
            lazy
            first={lazyParams.first}
            rows={lazyParams.rows}
            totalRecords={totalRecords}
            onPage={onPage}
            emptyMessage="Nenhum registro a ser exibido"
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            currentPageReportTemplate="{currentPage} de {totalPages}"
            rowsPerPageOptions={[10, 25, 50]}
          >
            {fillColumns(columnsSetup)}
          </DataTable>
        </div>

        <Dialog
          header="Confirmação"
          visible={showConfirmDialog}
          style={{ width: '50vw' }}
          footer={confirmDialogFooter}
          onHide={() => setShowConfirmDialog(false)}
        >
          <p>
            Excluir o registro?
          </p>
        </Dialog>
      </Card>
    </>
  );
}
